export const stepSummaryContainerStyles = {
  gap: '4px',
};

export const stepSummaryLabelStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const stepSummaryTextStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
